import { Resource } from "i18next";
import { compact, first, map, merge, uniq } from "lodash";
import { LANGUAGE_FALLBACKS } from "./constants";
import { getLanguageOverwrite, getNamespaceForBuildType } from "./resources";

const readResourceContent = async (lng: string, namespace: string) => {
  lng = getLanguageOverwrite(lng);

  return import(`../assets/language/${lng}/${namespace}.json`).then<string>((module) => module.default);
};

const readResourcesJSON = (lng: string, buildType: string) => {
  const namespace = getNamespaceForBuildType(buildType);
  if (!lng || !namespace) {
    throw new Error(`Invalid language or namespace: ${lng}, ${namespace}`);
  }
  return readResourceContent(lng, namespace);
};

export const getResources = async (lng: string, buildType: string): Promise<Resource> => {
  const resource = await readResourcesJSON(lng, buildType);

  const resources: Resource = {
    [lng]: {
      [getNamespaceForBuildType(buildType)]: resource,
    },
  };

  return resources;
};

export const mergeResources = (resources: Resource[]): Resource => {
  return resources.reduce((acc, res) => merge(acc, res), {});
};

export const getResourcesWithFallbacks = async (lng: string, buildType: string): Promise<Resource> => {
  const resources = await getResources(lng, buildType);
  const def = first(LANGUAGE_FALLBACKS.default) as string;
  const fallbacks = compact(uniq([...(LANGUAGE_FALLBACKS[lng] ?? []), def]));
  const fallbackResouresPromise = map(fallbacks, (fallbackLng) => getResources(fallbackLng, buildType));

  const fallbackResoures = await Promise.all(fallbackResouresPromise);

  return mergeResources([...fallbackResoures, resources]);
};
